import { GuidService } from 'ui-components/services/guid-service';
import * as BulkUpdateActions from '../../../store/bulk/update/bulk.update.actions';
import { BulkActions } from '../../../enums/bulk-actions';

export const ApplyShippingPreset = {
  id: 'apply-shipping-preset',
  name: BulkActions.applyShippingPreset.message,

  makeHandler: (dispatch, bulkUpdateTypeData) => {
    return (ids, filters) =>
      dispatch(
        BulkUpdateActions.startBulkUpdateJob(bulkUpdateTypeData, [BulkActions.applyShippingPreset], ids, GuidService.newGuid(), filters),
      );
  },
};
